import React from "react"
import { Field } from "react-final-form"

import { Grid } from "@mui/material"
import { map } from "ramda"

import { FilterGroup } from "./layout"
import { LabeledCheckbox } from "../../../atoms"

export const CheckboxesFilter = ({ items, title }) => {
  return (
    <FilterGroup xs={12} groupTitle={title} {...{ key }}>
      <Grid container justifyContent="start" spacing={1}>
        {map(
          ({ label, name }, labelIndex) => (
            <Grid item xs={4} key={`li${labelIndex}`}>
              <Field name={name}>
                {({ input }) => (
                  <LabeledCheckbox
                    {...input}
                    checked={input.checked}
                    color={"primary"}
                    label={label}
                  />
                )}
              </Field>
            </Grid>
          ),
          items,
        )}
      </Grid>
    </FilterGroup>
  )
}
